module.exports = __webpack_public_path__ + "static/media/site.60ce834f.webmanifest";